module.exports = __webpack_public_path__ + "img/logo.73f09f59.svg";